module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
if (behaviors) {
_.forEach(behaviors, function(behavior) {

    ; __append("\r\n    <li class=\"behavior-options\" style=\"display: block;\">\r\n        <a role=\"button\" class=\"behaviorLink ")
    ; __append(escapeFn(behavior.active))
    ; __append("\" data-objectid=\"")
    ; __append(escapeFn(id))
    ; __append("\"\r\n            data-behaviorkey=\"")
    ; __append(escapeFn(behavior.behaviorKey))
    ; __append("\">")
    ; __append(escapeFn( behavior.text))
    ; __append("\r\n        </a>\r\n    </li>\r\n")
    ; 
});
}

  }
  return __output;

}